import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <h1 className="font-heading text-4xl">Checkout cancelled.</h1>
      <p className="text-neutral-600 mt-4">No charges were made. You can return anytime.</p>
      <Link to="/events" className="inline-block mt-8"><Button className="rounded-full bg-black text-white btn-pill">Back to events</Button></Link>
    </div>
  );
}
